/*
	RegEx Methods   
*/
const regex_contains_alphaNumeric = /([0-9A-Za-z])/

const regexTesters = {
	methods: {
		constainsAlphaNumberic( input, defaultText, job) {
			if (job.is_request === true) {
				return ''
			}
			if (!input) return defaultText

			let test = input.match( regex_contains_alphaNumeric )
			let data = ( test ) ? input : defaultText
			
			return data
		}
	}
}

export default regexTesters